import { Component } from '@angular/core';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'wdx-ag-grid-boolean-cell-renderer',

    imports: [WdxIconModule],
    template: `
        <div class="text-center">
            @if (value) {
                <wdx-icon [scale]="1.5" icon="square-check"></wdx-icon>
            } @else {
                <wdx-icon [scale]="1.5" icon="square"></wdx-icon>
            }
        </div>
    `,
})
export class BooleanRendererComponent implements ICellRendererAngularComp {
    public value: boolean | null | undefined;

    agInit(params: ICellRendererParams<any, boolean>): void {
        this.value = params?.value;
    }

    refresh(params: ICellRendererParams<any, boolean>): boolean {
        this.agInit(params);
        return true;
    }
}
